import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import instance from "../../api/instance";
import { getCurrentHostname, isValidUrl } from "src/utils/functions";
import axios from "axios";
import { isBoolean } from 'lodash';
import { BASE_PATH, S3_BASE_URL } from "src/config/constants";

interface TArtifacts {
  business: string;
  logo: string;
  base_url: string;
  favicon: string;
  primary_color: string;
  theme_color?: string;
  current_domain: string;
  is_aura: boolean;
  is_socket: boolean;
  [key: string]: any;
}


const initArtifacts: Partial<TArtifacts> = {
  business: 'ALLPANELEXCH',
  base_url: 'https://allpanel.buzz',
  favicon: `${process.env.NODE_ENV === "development" ? "" : BASE_PATH}/favicon.ico`,
  logo: `${process.env.NODE_ENV === "development" ? "" : BASE_PATH}/logo512.png`,
  is_socket: true,
};

export const getDomainArtifacts = createAsyncThunk('common/getDomainArtifacts', async (_, { fulfillWithValue }) => {
  try {
    let domainName = getCurrentHostname(process.env.REACT_APP_FE_ORIGIN);

    const curDomain = getCurrentHostname();
    if (process.env.NODE_ENV === 'production' && curDomain) {
      domainName = curDomain;
    }
    const AppPath = `${S3_BASE_URL}/${domainName}/`;

    const response = await axios.get(`${AppPath}business.json`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    let artifacts: Partial<TArtifacts> = { ...initArtifacts, logo:"", favicon:"" };

    // const ArtifactObj =
    //   response && typeof response?.data === 'string'
    //     ? JSON.parse(response?.data)
    //     : response?.data;

    if (response?.data) {
      artifacts = {
        ...artifacts,
        ...response.data,
        current_domain: curDomain,
      };
    }


    if (artifacts?.logo) {
      const nLogo = artifacts.logo.startsWith('http') ? artifacts.logo : `${AppPath}${artifacts.logo}`;
      artifacts.logo = nLogo+ "?t=" + Date.now();;

    }

    if (artifacts?.favicon) {
      const nFavicon = artifacts.favicon.startsWith('http') ? artifacts.favicon : `${AppPath}${artifacts.favicon}`;
      artifacts.favicon = nFavicon+ "?t=" + Date.now();
    }

    // if (!artifacts?.logo) artifacts.logo = initArtifacts.logo;
    // if (!artifacts?.favicon) artifacts.favicon = initArtifacts.favicon;
    if (!isBoolean(artifacts?.is_socket)) artifacts.is_socket = true;
    if (artifacts?.business) artifacts.business = domainName;

    return {
      all: artifacts,
      app: {
        business: artifacts.business,
        logo: artifacts.logo,
        favicon: artifacts.favicon,
        is_socket: artifacts.is_socket,
        theme_color: artifacts.theme_color,
        base_url: artifacts.base_url,
      },
    };
  } catch (error) {
    console.error(`Error fetching domain artifacts:`, error);
    // return rejectWithValue(error);
    const tArtifacts: Partial<TArtifacts> = {
      ...initArtifacts,
      logo:"",
      favicon:"",
    };

    const curDomain = getCurrentHostname();
    if (curDomain) {
      tArtifacts.current_domain = curDomain;
      if( !tArtifacts.business ) tArtifacts.business = curDomain;
    }

    return fulfillWithValue({ all: tArtifacts, app: tArtifacts });
  }
});


interface appState {
  roles: any[];
  loading: boolean;
  leftBarGameId: string;
  leftBarLeagueId: string;
  artifacts?: Partial<TArtifacts>;
  allArtifacts?: Partial<TArtifacts>;
  isArtifactsLoading: boolean;
}

const initialState: appState = {
  roles: [],
  loading: false,
  leftBarGameId: "",
  leftBarLeagueId: "",
  isArtifactsLoading: true,
};

export const getUserRoles = createAsyncThunk("app/getUserRoles", async (_, { rejectWithValue }) => {
  try {
    const response = await instance.get("role/list");
    const data = await response?.data?.data;

    return data ?? { list: [], dataCount: 0 };
  } catch (error: any) {
    return rejectWithValue(error?.data);
  }
});

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setLeftBarGameId: (state, action) => {
      state.leftBarGameId = action.payload;
    },
    setLeftBarLeagueId: (state, action) => {
      state.leftBarLeagueId = action.payload;
    },
    setIsArtifactsLoading: (state, action) => {
      state.isArtifactsLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserRoles.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserRoles.fulfilled, (state, { payload: { list, dataCount } }) => {
        state.loading = false;
        state.roles = Array.isArray(list) ? list : [];
      })
      .addCase(getUserRoles.rejected, (state) => {
        state = initialState;
      });
    builder
      .addCase(getDomainArtifacts.pending, (state) => {
        state.isArtifactsLoading = true;
      })
      .addCase(getDomainArtifacts.fulfilled, (state, { payload }) => {
        state.artifacts = payload.app;
        state.allArtifacts = payload.all;
      })
      .addCase(getDomainArtifacts.rejected, (state) => {
        state.isArtifactsLoading = false;
      });
  },
});

export const { setLeftBarGameId, setLeftBarLeagueId, setIsArtifactsLoading } = appSlice.actions;

export default appSlice.reducer;
